import { create } from 'zustand';

/**
 * Open/close state for the notification bell dropdown, lifted to a store so it
 * can be opened from outside the bell — e.g. tapping a cancelled/removed OS push
 * that has no page to navigate to opens the feed instead.
 */
interface NotificationUiState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useNotificationUi = create<NotificationUiState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
